import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { useDispatch } from "react-redux";
import { addToCart, setItems } from "../../redux/amazonSlice";
import axios from "axios";
// import ProductDetail from "./ProductDetail";
import Skeleton from "../ui/Skeleton";
import {
  useQuery,
  // useMutation,
  // useQueryClient,
  // QueryClient,
} from "@tanstack/react-query";
import { BaseURL } from "../../App";
import { Link } from "react-router-dom";

const Products = () => {
  // const queryClient = useQueryClient();

  const dispatch = useDispatch();
  // const [selectedProduct, setSelectedProduct] = useState(null);
  // const [showProductDetail, setShowProductDetail] = useState(false);

  const fetchProducts = async () => {
    const response = await axios.get(`${BaseURL}/instruments`);

    const stringInstrumentsData = response.data.filter(
      (instrument) => instrument.category === "Musical Instruments"
    );

    dispatch(setItems(response.data));

    return stringInstrumentsData;
  };

  const {
    data: productData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["musicalInstruments"],
    queryFn: fetchProducts,
    staleTime: Infinity,
  });

  // usemutation for post request
  // const { mutate, isPending, isError, isSuccess } = useMutation({
  //   mutationFn: (newdata) =>
  //     fetch("", {
  //       method: "POST",
  //       body: JSON.stringify(newdata),
  //     }).then((res) => res.json()),
  //     onSuccess: () => {
  //       queryClient.setQueriesData(["musicalInstruments"], (oldData) => )
  //     }
  // });

  // useEffect(() => {
  //   // Prefetch the data when the component mounts
  //   queryClient.prefetchQuery(["musicalInstruments"], () =>
  //     axios.get(`${BaseURL}/instruments`)
  //   );
  // }, [queryClient]);

  // Handle loading state
  if (isLoading) {
    return <Skeleton />;
  }

  // Handle error state
  if (error) {
    return (
      <div className="text-red-500 flex justify-center">
        Error: {error.message}
        <button
          onClick={refetch}
          className="ml-2 px-3 py-1 bg-blue-950 text-white rounded-md hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Refresh
        </button>
      </div>
    );
  }

  // // Function to show product details
  // const showDetails = (product) => {
  //   setSelectedProduct(product);
  //   setShowProductDetail(true);
  // };

  // // Function to hide product details
  // const hideDetails = () => {
  //   setSelectedProduct(null);
  //   setShowProductDetail(false);
  // };

  return (
    <div>
      {/* <button
        onClick={() =>
          mutate({
            name: "shriniket",
          })
        }
      >
        click
      </button>{" "} */}
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10 xl:gap-4 px-4">
        {productData?.map((item) => (
          <div
            key={item.id}
            className="bg-white h-auto border-[1px] border-gray-200 py-6 z-30 hover:border-transparent shadow-none hover:shadow-testShadow duration-200 relative flex flex-col gap-4"
          >
            {" "}
            <span className="text-xs capitalize italic absolute top-2 right-2 text-gray-500">
              {item.category}
            </span>
            <div className="w-full h-auto flex items-center justify-center relative group">
              {/* ========== Product Image Start here ============== */}
              <img
                className="w-52 h-64 object-contain"
                src={item.image}
                alt=""
              />
              {/* ================== Product mini drop down Start here ============ */}
              <ul className="absolute w-full h-8 -bottom-4 flex flex-col justify-center items-end gap-2 pr-2">
                <li className="productLi">
                  <Link to={`/productDetails/${item.id}`}>
                    <span>
                      Details <ArrowCircleRightIcon />
                    </span>
                  </Link>
                </li>
                {/* Conditionally render the ProductDetail component */}
                {/* {showProductDetail && (
              <ProductDetail
                product={selectedProduct}
                onClose={hideDetails}
              />
            )} */}
              </ul>
              {/* ================== Product mini drop down End here ============== */}
            </div>
            <div className="px-4 py-0 bg-white flex flex-col z-10">
              <div className="flex items-center justify-between">
                <h2 className="font-titleFont tracking-wide text-lg text-amazon_blue font-medium">
                  {item.title}
                </h2>
                <p className="text-sm text-gray-600 font-semibold">
                  Rs.{item.price}
                </p>
              </div>
              <button
                onClick={() =>
                  dispatch(
                    addToCart({
                      _id: item._id,
                      id: item.id,
                      title: item.title,
                      description: item.description,
                      price: item.price,
                      category: item.category,
                      image: item.image,
                      quantity: 1,
                    })
                  )
                }
                className="bg-blue-950 flex items-center justify-center rounded-md px-5 py-2 text-center text-sm font-medium text-white focus:outline-none focus:ring-4 focus:ring-blue-300 hover:bg-blue-900"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-2 h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                Add to cart
              </button>
            </div>
          </div>
        ))}
      </div>
      <div class="m-10 mx-4 max-w-[1230px] overflow-hidden rounded-xl border shadow-lg md:pl-8">
        <div class="flex flex-col overflow-hidden bg-white md:flex-row md:h-80">
          <div class="flex w-full flex-col p-4 md:w-1/2 md:p-8 lg:w-3/5">
            <h2 class="text-xl font-bold text-gray-900 md:text-2xl lg:text-4xl">
              String Instruments
            </h2>
            <p class="mt-2 text-lg">By Shriniket Kulkarni</p>
            <p class="mt-4 mb-8 max-w-md text-gray-500">
              Unleash the melody with our newest and finest selection of string
              instruments!
            </p>
            <a
              href="/categories/Strings"
              class="group mt-auto flex w-full md:w-44 cursor-pointer select-none items-center justify-center rounded-md bg-blue-950 px-6 py-2 text-white transition"
            >
              <span class="text-white group flex w-full items-center justify-center rounded py-1 text-center font-bold">
                Shop now
              </span>
              <svg
                class="flex-0 group-hover:w-6 ml-4 h-6 w-0 transition-all"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </div>

          <div class="order-first ml-auto h-48 w-full bg-gray-700 md:order-none md:h-auto md:w-1/2 lg:w-2/5">
            <img
              class="h-full w-full object-cover"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQOocCh0A-562biprqFvd-EivaX9dfIjchuy8QVGHRnA&s"
              loading="lazy"
              alt="String Instruments"
            />
          </div>
        </div>
      </div>

      {/* <div class="mx-auto my-10 w-screen max-w-screen-xl px-4">
        <div class="to flex items-center rounded-xl bg-gradient-to-r from-blue-600 to-fuchsia-500 px-8 text-white shadow-lg">
          <div class="my-10 lg:my-8 lg:w-1/2">
            <h1 class="text-2xl font-bold">
              Explore our Music Instruments Store
            </h1>
            <p class="mt-4 text-lg">
              Discover a wide range of musical instruments, courses, and tutors
              to enhance your musical journey. Whether you're a beginner or a
              seasoned musician, we have everything you need to excel.
            </p>
            <button
              type="submit"
              class="group mt-4 mr-2 mb-4 flex cursor-pointer text-left text-xl font-semibold leading-tight text-white"
            >
              Explore Now
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="group-hover:ml-8 ml-4 h-7 w-7 transition-all"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
            </button>
          </div>
          <div class="hidden h-72 w-1/2 flex-shrink-0 justify-center lg:flex">
            <img
              class=""
              src="https://www.coachhousepianos.co.uk/wp-content/uploads/2022/07/yamaha-cfx-grand-pe1.jpg"
              alt=""
            />
          </div>
        </div>
      </div> */}

      <div class="mx-auto max-w-screen-lg bg-blue-950 p-8 text-white md:flex md:items-center md:justify-around md:p-16 lg:rounded-xl">
        <div class="mr-10 mb-10 md:mb-0">
          <h2 class="mb-8 max-w-lg text-3xl font-bold sm:text-4xl">
            SNK Music Store
          </h2>
          <ul class="flex max-w-xl flex-wrap gap-4">
            <li class="flex space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-6 w-6 text-green-300"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <p class="text-gray-100">
                MERN stack e-commerce site with Firebase auth, Redux Toolkit,
                React Query, and Redis caching.
              </p>
            </li>
            <li class="flex space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-6 w-6 text-green-300"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <p class="text-gray-100">
                Admin dashboard, Stripe integration, and Tailwind CSS UI.
              </p>
            </li>
            <li class="flex space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-6 w-6 text-green-300"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <p class="text-gray-100">
                Udemy API integration for courses and music class discovery.
              </p>
            </li>
            <li class="flex space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-6 w-6 text-green-300"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <p class="text-gray-100">
                Spotify API integration for music and ZegoCloud video calls.
              </p>
            </li>
            <li class="flex space-x-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="h-6 w-6 text-green-300"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <p class="text-gray-100">
                Dashboard updates and upcoming mobile app development.
              </p>
            </li>
          </ul>
        </div>
        <div class="whitespace-nowrap">
          <button class="focus:outline-4 rounded-xl bg-emerald-400 px-4 py-3 font-medium text-white shadow-md outline-white transition hover:bg-emerald-500">
            Stay Tuned!
          </button>
        </div>
      </div>
    </div>
  );
};

export default Products;
